
(function() {
  var result = { translations: { "ro": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} ore", "hoursAndMinutes": "{{ hours }} ore {{ minutes }} min", "days": "{{ days }} zile", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}z", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ro": "static-7.1305"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1305",
    "ar-eg": "static-7.1305",
    "bg": "static-7.1305",
    "bn": "static-7.1305",
    "ca-es": "static-7.1305",
    "cs": "static-7.1305",
    "da": "static-7.1305",
    "de": "static-7.1305",
    "el": "static-7.1305",
    "en-gb": "static-7.1305",
    "en": "static-7.1305",
    "es-mx": "static-7.1305",
    "es": "static-7.1305",
    "et": "static-7.1305",
    "fi": "static-7.1305",
    "fr-ca": "static-7.1305",
    "fr": "static-7.1305",
    "he-il": "static-7.1305",
    "hi": "static-7.1305",
    "hr": "static-7.1305",
    "hu": "static-7.1305",
    "id": "static-7.1305",
    "it": "static-7.1305",
    "ja": "static-7.1305",
    "ko": "static-7.1305",
    "lt": "static-7.1305",
    "ms": "static-7.1305",
    "nl": "static-7.1305",
    "no": "static-7.1305",
    "pl": "static-7.1305",
    "pt-br": "static-7.1305",
    "pt-pt": "static-7.1305",
    "ro": "static-7.1305",
    "ru": "static-7.1305",
    "sk": "static-7.1305",
    "sl": "static-7.1305",
    "sv": "static-7.1305",
    "th": "static-7.1305",
    "tl": "static-7.1305",
    "tr": "static-7.1305",
    "uk": "static-7.1305",
    "vi": "static-7.1305",
    "x-pseudo": "static-7.1305",
    "zh-cn": "static-7.1305",
    "zh-hk": "static-7.1305",
    "zh-tw": "static-7.1305"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ro', {version: 'static-7.1305'}); }
})();


